const tabs = document.querySelectorAll(".tab-collection-option");
const tabCollections = document.querySelectorAll("#tab-collection");
tabs.forEach((tab, i) => {
  tab.addEventListener("click", (event) => {
    if (event.target.classList.contains("current")) {
    } else {
      tabs.forEach((tab) => {
        tab.classList.remove("current");
      });
      tabCollections.forEach((tab) => {
        tab.classList.remove("current-collection");
      });

      tab.classList.add("current");
      tabCollections[i].classList.add("current-collection");
      const tabIndex = event.target.getAttribute("data-tab-id");
      const activeElementId = `tab-collection--${tabIndex}}`;
    }
  });
});
